<ng-container *transloco="let t; read: 'benefits'">
  <section class="teaser">
    <div class="teaser-pics">
      <div
        class="teaser teaser1 active"
        [ngStyle]="{ backgroundImage: images[0] }"
      ></div>
    </div>
    <div class="content">
      <div class="title">{{ t("title") }}</div>
    </div>
  </section>
  <section class="blocks" id="selection">
    <div class="blocks">
      <div #selection class="scrollAnchor"></div>
      <article class="same-height">
        <h3 class="top">{{ t("knowledge-transfer-title") }}</h3>
        <div>{{ t("knowledge-transfer-text") }}</div>
        <a class="call" (click)="scrollToTarget(knowledgeTransfer)">{{
          t("more")
        }}</a>
      </article>
      <article class="same-height">
        <h3 class="top">{{ t("development-title") }}</h3>
        <div>{{ t("development-text") }}</div>
        <a class="call" (click)="scrollToTarget(companyDevelopment)">{{
          t("more")
        }}</a>
      </article>
      <article class="same-height">
        <h3 class="top">{{ t("cost-savings-title") }}</h3>
        <div>{{ t("cost-savings-text") }}</div>
        <a class="call" (click)="scrollToTarget(costSaving)">{{ t("more") }}</a>
      </article>
      <article class="same-height">
        <h3 class="top">{{ t("effective-title") }}</h3>
        <div>{{ t("effective-text") }}</div>
        <a class="call" (click)="scrollToTarget(effective)">{{ t("more") }}</a>
      </article>
      <article class="same-height">
        <h3 class="top">{{ t("modern-title") }}</h3>
        <div>{{ t("modern-text") }}</div>
        <a class="call" (click)="scrollToTarget(modern)">{{ t("more") }}</a>
      </article>
      <article class="same-height">
        <h3 class="top">{{ t("international-title") }}</h3>
        <div>{{ t("international-text") }}</div>
        <a class="call" (click)="scrollToTarget(international)">{{
          t("more")
        }}</a>
      </article>
      <article class="same-height">
        <h3 class="top">{{ t("flexible-title") }}</h3>
        <div>{{ t("flexible-text") }}</div>
        <a class="call" (click)="scrollToTarget(flexible)">{{ t("more") }}</a>
      </article>
    </div>
  </section>
  <hr />
  <section class="article">
    <article>
      <div id="knowledgeTransfer" #knowledgeTransfer class="scrollAnchor"></div>
      <h2>{{ t("knowledge-transfer-title") }}</h2>
      <div class="text">
        <div [innerHTML]="t('knowledge-transfer-content-1')"></div>
        <div class="picture left">
          <img src="assets/tausend_worte.jpg" />
        </div>
        <div [innerHTML]="t('knowledge-transfer-content-2')"></div>
        <div class="picture right">
          <img src="assets/tausend_worte_loesung.jpg" />
        </div>
        <div [innerHTML]="t('knowledge-transfer-content-3')"></div>
      </div>
      <a class="call" (click)="scrollToTarget(selection)">{{
        t("back-button")
      }}</a>
    </article>
    <hr />

    <article>
      <div
        id="companyDevelopment"
        #companyDevelopment
        class="scrollAnchor"
      ></div>
      <h2>{{ t("development-title") }}</h2>
      <div class="text" [innerHTML]="t('development-content')"></div>
      <a class="call" (click)="scrollToTarget(selection)">{{
        t("back-button")
      }}</a>
    </article>
    <hr />

    <article>
      <div id="costSaving" #costSaving class="scrollAnchor"></div>
      <h2>{{ t("cost-savings-title") }}</h2>
      <div class="text" [innerHTML]="t('cost-savings-content')"></div>
      <a class="call" (click)="scrollToTarget(selection)">{{
        t("back-button")
      }}</a>
    </article>
    <hr />
    <article>
      <div #effective class="scrollAnchor"></div>
      <h2>{{ t("effective-title") }}</h2>
      <div class="text" [innerHTML]="t('effective-content')"></div>
      <div class="picture">
        <img src="assets/effektiv.jpg" />
      </div>
      <a class="call" (click)="scrollToTarget(selection)">{{
        t("back-button")
      }}</a>
    </article>
    <hr />
    <article>
      <div #modern class="scrollAnchor"></div>
      <h2>{{ t("modern-title") }}</h2>
      <div class="text" [innerHTML]="t('modern-content')"></div>
      <div class="picture">
        <img src="assets/modern.png" />
      </div>
      <a class="call" (click)="scrollToTarget(selection)">{{
        t("back-button")
      }}</a>
    </article>
    <hr />
    <article>
      <div #international class="scrollAnchor"></div>
      <h2>{{ t("international-title") }}</h2>
      <div class="text" [innerHTML]="t('international-content')"></div>
      <div class="picture">
        <img src="assets/international.jpg" />
      </div>
      <a class="call" (click)="scrollToTarget(selection)">{{
        t("back-button")
      }}</a>
    </article>
    <hr />
    <article>
      <div #flexible class="scrollAnchor"></div>
      <h2>{{ t("flexible-title") }}</h2>
      <div class="text" [innerHTML]="t('flexible-content')"></div>
      <div class="picture">
        <img src="assets/flexibel.jpg" />
      </div>
      <a class="call" (click)="scrollToTarget(selection)">{{
        t("back-button")
      }}</a>
    </article>
  </section>
</ng-container>
